import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../../styles";
import {PDFContext} from "../../BasePDF";


export const PurchaseDealerFinanceDetailsPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Finance Details</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text>Total Cash Price</Text>
                    <Text>{pdfData.total_cash_price.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween}}>
                    <Text>Fees</Text>
                    <Text>{pdfData.total_fees.toDollarFormat()}</Text>
                </View>
                {
                    pdfData.downpayment_from_rebate && pdfData.downpayment_from_rebate !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text>Down Payment from Rebate</Text>
                        <Text>{pdfData.downpayment_from_rebate.toDollarFormat()}</Text>
                    </View>
                }
                {
                    pdfData.trade_as_cap_reduction && pdfData.trade_as_cap_reduction !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text>Trade as Cap Reduction</Text>
                        <Text>{pdfData.trade_as_cap_reduction.toDollarFormat()}</Text>
                    </View>
                }

                <View style={baseStyles.flexBetween}>
                    <Text>Total Taxes ({pdfData.tax_rate})</Text>
                    <Text>{pdfData.total_taxes.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween}}>
                    <Text>Total Amount Financed</Text>
                    <Text>{pdfData.amount_financed.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween}}>
                    <Text>Finance Charge</Text>
                    <Text>{pdfData.finance_charge.toDollarFormat()}</Text>
                </View>

                {
                    pdfData.max_advance &&
                    <View style={baseStyles.flexBetween}>
                        <Text>
                            Max Advance
                        </Text>
                        <Text>{pdfData.max_advance.toDollarFormat()}</Text>
                    </View>
                }
            </View>
        </View>
    )
}